import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-header">
          <h2 className="section-title">Про Monxuan</h2>
          <p className="section-subtitle">
            Український бренд преміум догляду за волоссям, створений з любов'ю до природи та краси
          </p>
        </div>

        <div className="about-content">
          <div className="about-main">
            <div className="about-text">
              <div className="about-story">
                <h3>Про нас</h3>
                <p>
                  <b>Monxuan</b> народилася з глибокої пристрасті до здоров'я та краси волосся. З самого початку ми прагнемо створювати високоякісні продукти з приголомшливими результатами, які підходять для всіх типів волосся, але особливо спрямовані на дуже пошкоджене, позбавлене енергії та блиску волосся.
                </p>
                <p>
                  Наша історія почалася з гострої необхідності знайти реальні рішення проблем з волоссям, з якими стикаються жінки. Ми розуміли, що не існує універсального рішення, і що немає продуктів, які дійсно вирішують ці конкретні проблеми. Тому ми розпочали інтенсивний пошук та скрупульозне дослідження, яке зайняло більше двох років, щоб створити реальне рішення. За цей час ми співпрацювали з експертами в області догляду за волоссям і ретельно аналізували інгредієнти і формули існуючих засобів. Ця науково-дослідна подорож привела нас до створення бренду Monxuan.
                </p>
              </div>

              <div className="about-mission">
                <h3>Наше бачення</h3>
                <p>
                  Ця науково-дослідна подорож привела нас до створення бренду Monxuan. Ми заклали основи бренду, який базується на твердих принципах: якість, продуктивність та професіоналізм. Ми розробили продукти, які не тільки обіцяють, а й дають реальні результати.
                </p>
                <p>
                  Від шампуню до кондиціонера та маски, кожен продукт Monxuan ретельно розроблено, щоб допомогти вам мати здорове, блискуче волосся та в його найкращій формі.
                </p>
                <p>  
                  Одним з унікальних аспектів нашого бренду є унікальна здатність продуктів задовольняти різноманітні потреби всіх типів волосся.
                </p>
                <p>
                  Незалежно від того, чи є у вас кучеряве, фарбоване або сильно пошкоджене волосся, Monxuan є оптимальним рішенням. Наші вдосконалені формули були розроблені для відновлення, пожвавлення та захисту вашого волосся, забезпечуючи видимі та довготривалі результати.
                </p>
              </div>
              <div className="about-meaning">
                <h3>Значення</h3>
                <p>
                  Ми подбали про те, щоб кожен виріб Monxuan був не тільки ефективним, але й стильно виглядав у будь-якій ванній кімнаті.
                </p>
                <p>
                  Кожна деталь, від дизайну упаковки до вибору матеріалів, відображає наше прагнення до якості та естетики.
                </p>
                <p>
                  Ми запрошуємо вас відкрити для себе наш асортимент продукції та стати частиною спільноти Monxuan, де краса та здоров'я волосся є найважливішими!
                </p>
              </div>
            </div>

            <div className="about-image">
              <img 
                src="https://monxuan.ro/wp-content/uploads/2023/11/Capac-e1701346172743-copy.jpg" 
                alt="Monxuan продукція"
              />
              <img 
                src="https://monxuan.ro/wp-content/uploads/2023/11/science-1.jpg" 
                alt="Monxuan наука"
              />
              <img 
                src="https://monxuan.ro/wp-content/uploads/2023/11/Sampon-.jpg" 
                alt="Monxuan шампунь"
              />
            </div>
          </div>

          <div className="about-cta">
            <h3>Приєднуйтесь до родини Monxuan</h3>
            <p>
              Довірте догляд за своїм волоссям професіоналам та відкрийте для себе 
              новий рівень краси та здоров'я
            </p>
            <div className="cta-buttons">
              <a href="#shop" className="btn btn-primary">До магазину</a>
              <a href="#contact" className="btn btn-secondary">Зв'язатися з нами</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;